import React from 'react';
import { useAuth } from '../hooks/useAuth';

import AuthRoutes from './auth.routes';
import AppRoutes from './app.routes';
import { BrowserRouter } from 'react-router-dom';


const IndexRoutes: React.FC = () => {
    const { user } = useAuth();

    return (
        <BrowserRouter>
            { (!!user.name) ? <AppRoutes /> : <AuthRoutes /> }
        </BrowserRouter>
    )
};

export default IndexRoutes;